import { useColorScheme } from "@/hooks/useColorScheme";

export function Logo({
  color,
  variant,
  size = "md",
}: {
  color?: "black" | "white";
  variant: "logo-only" | "logo-with-text";
  size?: "sm" | "md" | "lg";
}) {
  const { colorScheme } = useColorScheme();

  if (color === undefined) {
    color = colorScheme === "light" ? "black" : "white";
  }

  const sizeMap = {
    sm: 20,
    md: 28,
    lg: 34,
  };

  let src = "";
  let width = sizeMap[size];
  const height = sizeMap[size];
  if (color === "black") {
    if (variant === "logo-only") {
      src = `/svgs/logos/logo-black.svg`;
    } else {
      src = `/svgs/logos/logo-black-with-text.svg`;
    }
  } else {
    if (variant === "logo-only") {
      src = `/svgs/logos/logo-white.svg`;
    } else {
      src = `/svgs/logos/logo-white-with-text.svg`;
    }
  }

  if (variant === "logo-with-text") {
    width = width * 5;
  }

  return (
    <img
      width={width}
      height={height}
      style={{
        minWidth: width + "px",
        minHeight: height + "px",
        maxWidth: width + "px",
        maxHeight: height + "px",
      }}
      src={src}
      alt="Logo"
    />
  );
}
